
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Tags',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'tags',
    initmutation:'tags/TAG_INIT_TAG',
    backlink:'supplier',
    duplicateable:true,
    helptext:"Unter einem Tag wird in diesem Program alles verstanden, was dem \n\
            späteren Auffinden hilft. Darunter fallen sowohl Wörter wie 'vegetarisch'\n\
            als auch die späteren 'Funktionen' wie 'Tellergericht' oder 'Beilage'.\n\
            Ins Name Feld kommt der Name des Tags. In dem 'Suchfeld' Kategorie wird ein\n\
            Sammelbegriff (z.Bsp. Allergene, Menü etc) ausgewählt. Der Haken speichert die Eingabe.\n\
            Das Kreuz verläßt das Formular ohne zu speichern."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};